import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiArrowLeft } from 'react-icons/fi';
import './TermsOfService.css';

const TermsOfService = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleBack = () => {
    if (user) {
      navigate('/profile');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="terms-page">
      <div className="terms-header-container">
        <button className="terms-back-btn" onClick={handleBack}>
          <FiArrowLeft /> {user ? 'Back to Profile' : 'Back to Login'}
        </button>
        <h1 className="terms-title">Terms & Conditions</h1>
        <p className="terms-subtitle">Last updated: June 9, 2026</p>
      </div>

      <div className="terms-card">
        <section className="terms-section">
          <h2>1. Agreement to Terms</h2>
          <p>
            By accessing or using the services of <strong>Shubham Computers (Shubink)</strong>, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use our services, mobile application, or website.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Smart Printing & Geofenced Delivery</h2>
          <p>
            Our rapid 30-minute delivery services are strictly geofenced within a <strong>3km radius</strong> of our physical store located at Opposite Gujjar Dharmshala, near Govt. Girls Senior Secondary School, Adarsh Nagar, Jhajjar, Haryana - 124103. 
          </p>
          <ul>
            <li>To qualify for home delivery, your registered delivery address coordinates must fall inside this geofence.</li>
            <li>Orders placed from locations outside the geofence will be processed as **Self-Collect (Store Pickup)** only. We do not ship or deliver beyond our 3km service boundary.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>3. Document Upload & Formatting</h2>
          <p>
            To fulfill your printing orders, you may upload PDF, Word, Excel, or image files. 
          </p>
          <ul>
            <li>You represent and warrant that you own the rights to, or have obtained all necessary licenses/permissions for, any content or documents you upload for printing.</li>
            <li>We reserve the right to refuse service for any materials that violate copyright laws, or contain explicit, threatening, or illegal content.</li>
            <li><strong>Data Privacy:</strong> All uploaded files are processed solely for the requested print job and are automatically purged from our servers immediately after physical print completion.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>4. Payments, Store Wallet, & Refunds</h2>
          <p>
            All digital payments are securely processed through Razorpay.
          </p>
          <ul>
            <li>Store credits added to your wallet balance are non-refundable and cannot be redeemed for cash. Wallet credits can only be used for purchases and print services inside the Shubink platform.</li>
            <li>In the event of an order cancellation or failure before printing has started, refunds will be credited back to your store wallet.</li>
            <li>Once physical printing of a document has commenced, the order cannot be cancelled, modified, or refunded.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>5. Delivery Timelines & Limitation of Liability</h2>
          <p>
            We strive to deliver all geofenced print orders within **30 minutes**. However, delivery times are estimates and may vary due to order queue volumes, traffic, weather conditions, or technical issues. Shubham Computers will not be liable for any direct or indirect losses caused by delivery delays.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. Account Security</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials (phone number and password) and all activities occurring under your account. You agree to notify us immediately of any unauthorized access.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Contact Information</h2>
          <p>
            For any queries or issues regarding these Terms, please contact us at:
          </p>
          <div className="terms-contact-details" style={{ lineHeight: '1.6' }}>
            <strong>Shubham Computers (Shubink)</strong><br />
            Opposite Gujjar Dharmshala, Near Govt. Girls Senior Secondary School, Adarsh Nagar, Jhajjar, Haryana - 124103, India<br />
            <a 
              href="https://maps.google.com/?q=28.605441,76.653198" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ color: 'var(--primary-light)', display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 4, marginBottom: 6, textDecoration: 'none', fontWeight: '600' }}
            >
              📍 View Store Location on Google Maps
            </a><br />
            Email: <a href="mailto:shubhamcybercafe001@gmail.com" style={{ color: 'var(--primary-light)' }}>shubhamcybercafe001@gmail.com</a><br />
            Phone: <a href="tel:+919350336367" style={{ color: 'var(--primary-light)' }}>+91 93503 36367</a>
          </div>
        </section>
      </div>
      <div className="fab-spacer"></div>
    </div>
  );
};

export default TermsOfService;
